import { faker } from "@faker-js/faker";
import { Factory } from "fishery";
import {
  Payable,
  Payables,
} from "../components/PayableWorkflows/components/PayablesTable/types";
import { toGlobalId } from "../utils/graphql_utils";
import { moneyFactory } from "./money.factory";

export const payableFactory = Factory.define<Payable>(({ sequence }) => {
  return {
    __typename: "PayableObjectType",
    id: toGlobalId("PayableObjectType", sequence),
    description: faker.lorem.sentence(),
    invoiceNumber: faker.string.alphanumeric(8).toUpperCase(),
    invoiceDate: faker.date.past().toISOString().split("T")[0],
    dueDate: faker.date.future().toISOString().split("T")[0],
    createdAt: faker.date.past().toISOString(),
    amount: moneyFactory.build(),
    payee: {
      __typename: "PayeeObjectType",
      id: toGlobalId("PayeeObjectType", faker.number.int()),
      name: faker.company.name(),
    },
    arena: {
      __typename: "ArenaObjectType",
      id: toGlobalId("ArenaObjectType", faker.number.int()),
      name: faker.company.name(),
    },
    entity: {
      __typename: "AccountObjectType",
      id: toGlobalId("AccountObjectType", faker.number.int()),
      name: faker.company.name(),
    },
  };
});

interface PayablesTransientParams {
  payablesCountPerPage?: number;
}

export const payablesFactory = Factory.define<Payables, PayablesTransientParams>(
  ({ transientParams }) => {
    const { payablesCountPerPage = 20 } = transientParams;
    const payables: Payable[] = [];

    for (let i = 0; i < payablesCountPerPage; i++) {
      payables.push(payableFactory.build());
    }

    return {
      count: 50,
      pageInfo: {
        startCursor: faker.string.alphanumeric(),
        endCursor: faker.string.alphanumeric(),
        hasNextPage: true,
        hasPreviousPage: false,
      },
      edges: payables.map((node) => ({
        node,
      })),
    };
  },
);
